import { withServerSideProxy } from './proxy';
const localStorageHelpers = {
  getLocalStorageItem: key => localStorage.getItem(key),
  removeLocalStorageItem: key => localStorage.removeItem(key),
  setLocalStorageItem: (key, value) => localStorage.setItem(key, value)
};
const serverSafeLocalStorageHelpers = withServerSideProxy(localStorageHelpers, {
  getLocalStorageItem: () => null
});
export const {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem
} = serverSafeLocalStorageHelpers;